import { defineStore } from 'pinia';
import { useHttp } from '@/http/http';
import { statusCheck } from '../public';
import Swal from 'sweetalert2';


export const useRoleStore = defineStore('role', {
  state: () => ({
    roles: [],
    roleInfo: null,
    totalEntries: 0,
    sort_by: 'role_id',
    order: 'desc',
    isLoading: false,
  }),
  actions: {
    async fetchRoles(page = 1, perPage = 10) {
      if (this.isLoading) return;
      
      this.isLoading = true;
      const url = `/api/admin/member/roles`;
      try {
        const response = await useHttp().get(url, {
          params: {
            per_page: perPage,
            page: page,
            sort_by: this.sort_by,
            order: this.order
          }
        });
        this.roles = response.data.roles || [];
        this.totalEntries = this.roles.length;
      } catch (error) {
        console.error('Error fetching roles:', error);
        this.roles = [];
        this.totalEntries = 0;
        throw error;
      } finally {
        this.isLoading = false;
      }
    },
    async fetchRoleInfo(role_id) {
      if (this.isLoading) return;
      
      this.isLoading = true;
      const url = `/api/admin/member/role-info`;
      try {
        const response = await useHttp().get(url, {
          params: {
            id: role_id
          }
        });
        if (response.data && response.data.role) {
          this.roleInfo = response.data.role;
        } else {
          throw new Error('角色資訊格式錯誤');
        }
      } catch (error) {
        console.error('Error fetching role info:', error);
        this.roleInfo = null;
        throw error;
      } finally {
        this.isLoading = false;
      }
    },
    async updateRole(payload) {
      if (this.isLoading) return;
      
      this.isLoading = true;
      try {
        const response = await useHttp().post('/api/admin/member/role-permissions', payload);
        if(statusCheck(response.data)){
          Swal.fire({
            icon: 'success',
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500
          });
          await this.fetchRoles();
        }
      } catch (error) {
        console.error('Error updating roles:', error);
        throw error;
      } finally {
        this.isLoading = false;
      }
    },
  },
});
